/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Load_Project_File_Status_ImportingInputs */



/**
* | output |
* | --- |
* | "Importing project file:" |
*
* @param {Load_Project_File_Status_ImportingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const load_project_file_status_importing = /** @type {((inputs?: Load_Project_File_Status_ImportingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Load_Project_File_Status_ImportingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du fichier projet :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projektdatei wird importiert:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del file di progetto:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт файла проекта:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importando archivo de proyecto:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入项目文件：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト ファイルをインポートしています:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट फ़ाइल आयात करना:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importando arquivo de projeto:")
	return /** @type {LocalizedString} */ ("Importing project file:")
});